import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPaymentItem.Export.IRequest;
type Response = Api.Finance.ClaimJobPaymentItem.Export.IResponse;
type Headers = Api.Finance.ClaimJobPaymentItem.Export.IHeaders;
const url = '/api/Finance/ClaimJobPaymentItem/ExportToExcel';
export default async function claimJobPaymentItemExportApi(query: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, null, query),
    headers: getDefaultHeaders(),
  });
}
